import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/shop/pyo-ji2-8.tec_-sang-dam-ko-ching_-y1742876210619a.jpg?type=myboard&data_idx=944921&col_num=21&dir_name=sub3_2&thum_w=600&thum_h=600&thum_cut_yn=0'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/coaching/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'Expert',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "상담코칭",
      subtitle: "상담코칭",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(BoardNavbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "TOCC_학습진로상담코칭", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", null, [
            _createElementVNode("ul", { class: "line line4" }, [
              _createElementVNode("li", null, "TEC 상담코칭"),
              _createElementVNode("li", null, [
                _createElementVNode("dl", { class: "line2" }, [
                  _createElementVNode("dt", null, "제목"),
                  _createElementVNode("dd", null, "세상을 통해 최고의 나를 만나다!")
                ])
              ])
            ])
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("figure", null, [
                  _createVNode(_component_n_space, { justify: "center" }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ])),
                    _: 1
                  })
                ])
              ]),
              _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-7670a15e><dl data-v-7670a15e><dt data-v-7670a15e>목적</dt><dd data-v-7670a15e><br data-v-7670a15e> “학습진로 상담코칭“은 학생의 TEC 창의역량검사 결과를 바탕으로 학업 문제를 해결하고 미래의 성장과 변화를 안내하는 데 목적이 있다. </dd></dl><dl data-v-7670a15e><dt data-v-7670a15e>목표</dt><dd data-v-7670a15e> 목표1. 상담자는 상담 시작 전, 학생의 TEC 결과리포트 내용을 파악하고, 타 자료를 통해 학업 상태를 확인한다.<br data-v-7670a15e> 목표2. 상담자는 학생과 함께 학생의 TEC 결과를 공유하고 학업 상황에 관한 학생의 인식을 확인한다.<br data-v-7670a15e> 목표3. 상담자는 TEC 결과를 재해석하여 문제정의하고, 창의역량의 재구조화를 위한 목표 설정 및 전략을 제시한다.<br data-v-7670a15e> 목표4. 상담자는 학생이 목표 도달하는데 도움이 될 다양한 경험을 탐색하도록 안내하고, 실행안을 조직한다.<br data-v-7670a15e> 목표5. 상담자는 학생이 목표 도달을 위한 자발적 관리 및 사회 활동을 통한 네트워크 활동을 권유한다. </dd></dl><dl data-v-7670a15e><dt data-v-7670a15e>대상</dt><dd data-v-7670a15e><br data-v-7670a15e> 대1- 대4 </dd></dl><dl class=\"line2\" data-v-7670a15e><dt data-v-7670a15e>구분·시수</dt><dd data-v-7670a15e>1시간 (1인 기준; 실제 시간: 20분 내외)</dd></dl></li>", 1))
            ])
          ]),
          _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-7670a15e><ul class=\"line line4\" data-v-7670a15e><li data-v-7670a15e> 결과물<br data-v-7670a15e> • TEC 기반 목표 및 전략 수립<br data-v-7670a15e> • 창의역량의 재구조화 실행안<br data-v-7670a15e> • 다양한 경험 탐색 보드 </li><li data-v-7670a15e><dl class=\"line2\" data-v-7670a15e><dt data-v-7670a15e>구성</dt><dd data-v-7670a15e> • (상담 전 단계) TEC 결과의 이해: (1) TEC 결과 확인, (2) 학업 활동 확인<br data-v-7670a15e> • (상담 단계) 학생과의 TEC 결과 공유 및 학업 상태 확인: (1) TEC 결과 공유, (2) (현재) 학업 상황에 대한 인식 확인<br data-v-7670a15e> • (코칭단계) 문제 정의 및 학습목표설정 및 전략 수립: (1) 진로 상담 및 문제해결, (2) 학습목표설정 및 전략 수립<br data-v-7670a15e> • (종료단계) 학습 목표 및 전략 실행안 조직: (1) 실행 목록 만들기, (2) 적합한 경험 경로 찾기<br data-v-7670a15e> • (상담 종류 후 단계) 실행을 위한 중장기 체크리스트 활용하기, 동아리 활동 탐색 </dd></dl></li></ul></div><div data-v-7670a15e><ul class=\"line box22\" data-v-7670a15e><li data-v-7670a15e> 강의<br data-v-7670a15e> • 다중재능코칭 전문가<br data-v-7670a15e> • 다중재능코칭 전문가 교육 - 초급과정, 고급과정, 또는 최고과정 이수자 </li><li data-v-7670a15e><dl class=\"line2\" data-v-7670a15e><dt data-v-7670a15e>이수혜택</dt><dd data-v-7670a15e><br data-v-7670a15e> 자기 이해 및 자기 관리 자료로 활용 </dd></dl></li></ul></div>", 2)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Product.Coaching.Tocc.Path}`
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("목록")
              ])),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}
}

})